module.exports = __webpack_public_path__ + "static/media/locked-card.f4064bb8.png";